module.exports = __webpack_public_path__ + "1176ea281282d6b053af86809e32d6f9.svg";